import { VacuumIndustryInfo } from "../schema-types";

export const vacuumCannonMuskegonOptions = {
  category: "Cannon-Muskegon Title",
  options: [
    {
      label: "B 1900",
      value: "B 1900"
    },
    {
      label: "B 1900 +HF",
      value: "B 1900 +HF"
    },
    {
      label: "B 1910",
      value: "B 1910"
    },
    {
      label: "CM 681LC©",
      value: "CM 681LC©"
    },
    {
      label: "Ni – C",
      value: "Ni – C"
    },
    {
      label: "Ni – X",
      value: "Ni – X"
    },
    {
      label: "IN 100",
      value: "IN 100"
    },
    {
      label: "IN 625",
      value: "IN 625"
    },
    {
      label: "IN 713 C",
      value: "IN 713 C"
    },
    {
      label: "IN 713 LC",
      value: "IN 713 LC"
    },
    {
      label: "IN 718",
      value: "IN 718"
    },
    {
      label: "IN 738 LC",
      value: "IN 738 LC"
    },
    {
      label: "IN 738 C",
      value: "IN 738 C"
    },
    {
      label: "IN 792 (MOD 5A)",
      value: "IN 792 (MOD 5A)"
    },
    {
      label: "IN 792 +HF",
      value: "IN 792 +HF"
    },
    {
      label: "IN 939",
      value: "IN 939"
    },
    {
      label: "CM 939 Weldable ®",
      value: "CM 939 Weldable ®"
    },
    {
      label: "Mar M 002*",
      value: "Mar M 002*"
    },
    {
      label: "Mar M 004",
      value: "Mar M 004"
    },
    {
      label: "Mar M 200",
      value: "Mar M 200"
    },
    {
      label: "Mar M 246",
      value: "Mar M 246"
    },
    {
      label: "Mar M 247*",
      value: "Mar M 247*"
    },
    {
      label: "CM 247 LC®*",
      value: "CM 247 LC®*"
    },
    {
      label: "Mar M 421",
      value: "Mar M 421"
    },
    {
      label: "Rene' 41",
      value: "Rene' 41"
    },
    {
      label: "Rene' 77",
      value: "Rene' 77"
    },
    {
      label: "Rene' 80",
      value: "Rene' 80"
    },
    {
      label: "Rene' 95",
      value: "Rene' 95"
    },
    {
      label: "Rene' 125",
      value: "Rene' 125"
    },
    {
      label: "Rene' 220",
      value: "Rene' 220"
    },
    {
      label: "U 500",
      value: "U 500"
    },
    {
      label: "U 700",
      value: "U 700"
    },
    {
      label: "Waspaloy",
      value: "Waspaloy"
    },
    {
      label: "Weldable Waspaloy",
      value: "Weldable Waspaloy"
    },
    {
      label: "C 263",
      value: "C 263"
    },
    {
      label: "C 1023",
      value: "C 1023"
    },
    {
      label: "GMR 235",
      value: "GMR 235"
    },
    {
      label: "GTD 111",
      value: "GTD 111"
    },
    {
      label: "GTD 222",
      value: "GTD 222"
    },
    {
      label: "GTD 444",
      value: "GTD 444"
    },
    {
      label: "Mar M 200 +HF",
      value: "Mar M 200 +HF"
    },
    {
      label: "Mar M 002",
      value: "Mar M 002"
    },
    {
      label: "Mar M 247",
      value: "Mar M 247"
    },
    {
      label: "PWA 1426",
      value: "PWA 1426"
    },
    {
      label: "Rene' 142",
      value: "Rene' 142"
    },
    {
      label: "CM 186 LC®**",
      value: "CM 186 LC®**"
    },
    {
      label: "CM 247 LC®",
      value: "CM 247 LC®"
    },
    {
      label: "Rene' 80 H",
      value: "Rene' 80 H"
    },
    {
      label: "GTD 111 M",
      value: "GTD 111 M"
    },
    {
      label: "PWA 1480",
      value: "PWA 1480"
    },
    {
      label: "PWA 1484",
      value: "PWA 1484"
    },
    {
      label: "PWA 1487",
      value: "PWA 1487"
    },
    {
      label: "Rene' N4",
      value: "Rene' N4"
    },
    {
      label: "Rene' N5",
      value: "Rene' N5"
    },
    {
      label: "Rene' N6",
      value: "Rene' N6"
    },
    {
      label: "CM 186 LC®",
      value: "CM 186 LC®"
    },
    {
      label: "CMSX-2®",
      value: "CMSX-2®"
    },
    {
      label: "CMSX-3®",
      value: "CMSX-3®"
    },
    {
      label: "CMSX-4®",
      value: "CMSX-4®"
    },
    {
      label: "CMSX-4® (SLS)[La+Y]",
      value: "CMSX-4® (SLS)[La+Y]"
    },
    {
      label: "CMSX-4® [B/C][MK4]",
      value: "CMSX-4® [B/C][MK4]"
    },
    {
      label: "CMSX-6®",
      value: "CMSX-6®"
    },
    {
      label: "CMSX-10K®",
      value: "CMSX-10K®"
    },
    {
      label: "CMSX-10N®",
      value: "CMSX-10N®"
    },
    {
      label: "CMSX 486®",
      value: "CMSX 486®"
    },
    {
      label: "SRR 99",
      value: "SRR 99"
    },
    {
      label: "RR 2000",
      value: "RR 2000"
    },
    {
      label: "AM 1",
      value: "AM 1"
    },
    {
      label: "AM 3",
      value: "AM 3"
    },
    {
      label: "SC 180",
      value: "SC 180"
    },
    {
      label: "MC-2",
      value: "MC-2"
    },
    {
      label: "FSX-414",
      value: "FSX-414"
    },
    {
      label: "Mar-M-302",
      value: "Mar-M-302"
    },
    {
      label: "Mar-M-509",
      value: "Mar-M-509"
    },
    {
      label: "Mar-M-918",
      value: "Mar-M-918"
    },
    {
      label: "HS 21",
      value: "HS 21"
    },
    {
      label: "HS 31 (X-40)",
      value: "HS 31 (X-40)"
    },
    {
      label: "X-45",
      value: "X-45"
    },
    {
      label: "HS 25 (L-605)",
      value: "HS 25 (L-605)"
    },
    {
      label: "Haynes 188",
      value: "Haynes 188"
    },
    {
      label: "AiResist 13",
      value: "AiResist 13"
    },
    {
      label: "AiResist 213",
      value: "AiResist 213"
    },
    {
      label: "AiResist 215",
      value: "AiResist 215"
    },
    {
      label: "F-75",
      value: "F-75"
    },
    {
      label: "WI-52",
      value: "WI-52"
    },
    {
      label: "ECY 768",
      value: "ECY 768"
    }
  ]
};

export const vacuumAmsOptions = {
  category: "AMS",
  options: [
    {
      label: "5405",
      value: "5405"
    },
    {
      label: "5406",
      value: "5406"
    },
    {
      label: "5388",
      value: "5388"
    },
    {
      label: "5389",
      value: "5389"
    },
    {
      label: "5390",
      value: "5390"
    },
    {
      label: "5397",
      value: "5397"
    },
    {
      label: "5401",
      value: "5401"
    },
    {
      label: "5391",
      value: "5391"
    },
    {
      label: "5377",
      value: "5377"
    },
    {
      label: "5383",
      value: "5383"
    },
    {
      label: "5399",
      value: "5399"
    },
    {
      label: "5384",
      value: "5384"
    },
    {
      label: "5385",
      value: "5385"
    },
    {
      label: "5382",
      value: "5382"
    }
  ]
};

export const vacuumprattAndWhitneyOptions = {
  category: "Pratt and Whitney",
  options: [
    {
      label: "663",
      value: "663"
    },
    {
      label: "1455",
      value: "1455"
    },
    {
      label: "658 / 1494",
      value: "658 / 1494"
    },
    {
      label: "1468",
      value: "1468"
    },
    {
      label: "655",
      value: "655"
    },
    {
      label: "649 / 1469 / 1490",
      value: "649 / 1469 / 1490"
    },
    {
      label: "1451",
      value: "1451"
    },
    {
      label: "1456",
      value: "1456"
    },
    {
      label: "1495",
      value: "1495"
    },
    {
      label: "1498",
      value: "1498"
    },
    {
      label: "659",
      value: "659"
    },
    {
      label: "1447 / 1489",
      value: "1447 / 1489"
    },
    {
      label: "1435",
      value: "1435"
    },
    {
      label: "656",
      value: "656"
    },
    {
      label: "652 / 1471",
      value: "652 / 1471"
    },
    {
      label: "1471",
      value: "1471"
    },
    {
      label: "1422",
      value: "1422"
    },
    {
      label: "1426",
      value: "1426"
    },
    {
      label: "1480",
      value: "1480"
    },
    {
      label: "1484",
      value: "1484"
    },
    {
      label: "1487",
      value: "1487"
    },
    {
      label: "CPW 637",
      value: "CPW 637"
    },
    {
      label: "657",
      value: "657"
    },
    {
      label: "647",
      value: "647"
    }
  ]
};

export const vacuumGeneralElectricOptions = {
  category: "General Electric",
  options: [
    {
      label: "C50TF23",
      value: "C50TF23"
    },
    {
      label: "B50TF107",
      value: "B50TF107"
    },
    {
      label: "B50T1239",
      value: "B50T1239"
    },
    {
      label: "B50T68 / B50TF16",
      value: "B50T68 / B50TF16"
    },
    {
      label: "B50A563",
      value: "B50A563"
    },
    {
      label: "C50TF83-S5",
      value: "C50TF83-S5"
    },
    {
      label: "C50T53 / C50TF2",
      value: "C50T53 / C50TF2"
    },
    {
      label: "C50TF15 / C50T67",
      value: "C50TF15 / C50T67"
    },
    {
      label: "C50TF47 / C50TF28",
      value: "C50TF47 / C50TF28"
    },
    {
      label: "C50TF77",
      value: "C50TF77"
    },
    {
      label: "C50TF60",
      value: "C50TF60"
    },
    {
      label: "C50TF91",
      value: "C50TF91"
    },
    {
      label: "C50T39",
      value: "C50T39"
    },
    {
      label: "C50TF15",
      value: "C50TF15"
    },
    {
      label: "B50A719",
      value: "B50A719"
    },
    {
      label: "C50TF101, B50A850",
      value: "C50TF101, B50A850"
    },
    {
      label: "B50AG18",
      value: "B50AG18"
    },
    {
      label: "C50TF94",
      value: "C50TF94"
    },
    {
      label: "C50TF74",
      value: "C50TF74"
    },
    {
      label: "B50A858",
      value: "B50A858"
    },
    {
      label: "C50TF82",
      value: "C50TF82"
    },
    {
      label: "C50TF87",
      value: "C50TF87"
    },
    {
      label: "C50TF114-S6",
      value: "C50TF114-S6"
    },
    {
      label: "B50A489",
      value: "B50A489"
    },
    {
      label: "B50TF89",
      value: "B50TF89"
    },
    {
      label: "C50TF21",
      value: "C50TF21"
    },
    {
      label: "B50TF144",
      value: "B50TF144"
    }
  ]
};

export const vacuumRollsRoycePlcOptions = {
  category: "Rolls Royce PLC (MSRR)",
  options: [
    {
      label: "7047",
      value: "7047"
    },
    {
      label: "7198",
      value: "7198"
    },
    {
      label: "7048",
      value: "7048"
    },
    {
      label: "7132",
      value: "7132"
    },
    {
      label: "7173",
      value: "7173"
    },
    {
      label: "7125",
      value: "7125"
    },
    {
      label: "7133",
      value: "7133"
    },
    {
      label: "7228",
      value: "7228"
    },
    {
      label: "7080 / 7101",
      value: "7080 / 7101"
    },
    {
      label: "7046",
      value: "7046"
    },
    {
      label: "7040",
      value: "7040"
    },
    {
      label: "7046",
      value: "7046"
    },
    {
      label: "7150",
      value: "7150"
    },
    {
      label: "7248 / 7257",
      value: "7248 / 7257"
    },
    {
      label: "7260",
      value: "7260"
    },
    {
      label: "7268",
      value: "7268"
    },
    {
      label: "7210",
      value: "7210"
    },
    {
      label: "7225",
      value: "7225"
    }
  ]
};

export const vacuumRollsRoyceCorpOptions = {
  category: "Rolls Royce Corp (EMS)",
  options: [
    {
      label: "73638",
      value: "73638"
    },
    {
      label: "73651",
      value: "73651"
    },
    {
      label: "73632 / 73648",
      value: "73632 / 73648"
    },
    {
      label: "73618 / 73665",
      value: "73618 / 73665"
    },
    {
      label: "73661",
      value: "73661"
    },
    {
      label: "73657",
      value: "73657"
    },
    {
      label: "73667",
      value: "73667"
    },
    {
      label: "73685",
      value: "73685"
    },
    {
      label: "72646",
      value: "72646"
    },
    {
      label: "73680 / 73683 / 73684",
      value: "73680 / 73683 / 73684"
    },
    {
      label: "73687",
      value: "73687"
    },
    {
      label: "73649",
      value: "73649"
    },
    {
      label: "73670",
      value: "73670"
    },
    {
      label: "73644",
      value: "73644"
    },
    {
      label: "73669",
      value: "73669"
    },
    {
      label: "73635",
      value: "73635"
    },
    {
      label: "73691",
      value: "73691"
    },
    {
      label: "73687 / 73688",
      value: "73687 / 73688"
    },
    {
      label: "73735",
      value: "73735"
    },
    {
      label: "73734",
      value: "73734"
    },
    {
      label: "73654",
      value: "73654"
    },
    {
      label: "73700",
      value: "73700"
    },
    {
      label: "73725",
      value: "73725"
    }
  ]
};

export const vacuumHoneywellOptions = {
  category: "Honeywell (EMS)",
  options: [
    {
      label: "55089",
      value: "55089"
    },
    {
      label: "55431",
      value: "55431"
    },
    {
      label: "55371",
      value: "55371"
    },
    {
      label: "55079 / 55444",
      value: "55079 / 55444"
    },
    {
      label: "55422",
      value: "55422"
    },
    {
      label: "55445",
      value: "55445"
    },
    {
      label: "55450",
      value: "55450"
    },
    {
      label: "55448",
      value: "55448"
    },
    {
      label: "55437",
      value: "55437"
    },
    {
      label: "55447",
      value: "55447"
    },
    {
      label: "55380",
      value: "55380"
    },
    {
      label: "55472",
      value: "55472"
    },
    {
      label: "55462",
      value: "55462"
    },
    {
      label: "55465",
      value: "55465"
    },
    {
      label: "55451",
      value: "55451"
    }
  ]
};

export const vacuumSafranOptions = {
  category: "Safran (DMD)",
  options: [
    {
      label: "0432-32",
      value: "0432-32"
    },
    {
      label: "0421-32",
      value: "0421-32"
    },
    {
      label: "0423-32",
      value: "0423-32"
    },
    {
      label: "9013-32",
      value: "9013-32"
    },
    {
      label: "0437-32",
      value: "0437-32"
    },
    {
      label: "0429-32",
      value: "0429-32"
    },
    {
      label: "0472-32",
      value: "0472-32"
    },
    {
      label: "0449-32",
      value: "0449-32"
    },
    {
      label: "0484-32",
      value: "0484-32"
    },
    {
      label: "9029-32",
      value: "9029-32"
    },
    {
      label: "0401-32",
      value: "0401-32"
    }
  ]
};

export const VACUUM_INDUSTRY_OPTIONS: VacuumIndustryInfo[] = [
  vacuumCannonMuskegonOptions,
  vacuumAmsOptions,
  vacuumprattAndWhitneyOptions,
  vacuumGeneralElectricOptions,
  vacuumRollsRoycePlcOptions,
  vacuumRollsRoyceCorpOptions,
  vacuumHoneywellOptions,
  vacuumSafranOptions
];
